import {
  mdiAccount,
  mdiAccountCircle,
  mdiAccountGroupOutline,
  mdiAlert,
  mdiApps,
  mdiBookOpen,
  mdiCalendarRangeOutline,
  mdiCalendarToday,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiClockTimeFourOutline,
  mdiClose,
  mdiCommentQuote,
  mdiHelpCircleOutline,
  mdiHome,
  mdiLogin,
  mdiLogout,
  mdiMagnify,
  mdiMapMarker,
  mdiMinus,
  mdiNewspaper,
  mdiPencil,
  mdiPlus,
  mdiPoll,
  mdiRoomService,
  mdiShopping,
  mdiSilverware,
  mdiStar,
  mdiTableChair,
  mdiTextBox,
  mdiWallet,
} from '@mdi/js';

export const mdiSvg = {
  alert: mdiAlert,
  account: mdiAccount,
  accountCircle: mdiAccountCircle,
  accountGroupOutline: mdiAccountGroupOutline,
  apps: mdiApps,
  book: mdiBookOpen,
  calendarToday: mdiCalendarToday,
  calendarRangeOutline: mdiCalendarRangeOutline,
  chevronRight: mdiChevronRight,
  chevronDown: mdiChevronDown,
  chevronUp: mdiChevronUp,
  clockTimeFourOutline: mdiClockTimeFourOutline,
  close: mdiClose,
  comment: mdiCommentQuote,
  helpCircleOutline: mdiHelpCircleOutline,
  home: mdiHome,
  login: mdiLogin,
  logout: mdiLogout,
  mapMarker: mdiMapMarker,
  magnify: mdiMagnify,
  minus: mdiMinus,
  newspaper: mdiNewspaper,
  pencil: mdiPencil,
  plus: mdiPlus,
  poll: mdiPoll,
  roomService: mdiRoomService,
  silverware: mdiSilverware,
  shopping: mdiShopping,
  star: mdiStar,
  tableChair: mdiTableChair,
  textBox: mdiTextBox,
  wallet: mdiWallet,
};
